/**
 * Searches for one or more permissions across all roles in a login response.
 * @param response - Login API response containing user.roles[].permissions[]
 * @param permissions - A single permission name or an array of permission names
 * @param mode - "some": at least one permission must match (default) | "every": all permissions must match
 */
export function searchPermissionInRoles(response, permissions, mode) {
    var _a;
    if (mode === void 0) { mode = "some"; }
    var required = Array.isArray(permissions) ? permissions : [permissions];
    var roles = ((_a = response === null || response === void 0 ? void 0 : response.user) === null || _a === void 0 ? void 0 : _a.roles) || [];
    var allGranted = roles.flatMap(function (role) {
        return ((role === null || role === void 0 ? void 0 : role.permissions) || []).map(function (p) { return p === null || p === void 0 ? void 0 : p.name; }).filter(Boolean);
    });
    if (mode === "every") {
        return required.every(function (p) { return allGranted.includes(p); });
    }
    return required.some(function (p) { return allGranted.includes(p); });
}
